import React, {useState} from "react";
import {
    Button,
    Field,
    makeStyles,
    Spinner,
    Textarea,
} from "@fluentui/react-components";
import {CalligraphyPenCheckmark20Regular, PenSparkle20Regular} from "@fluentui/react-icons";
import {getSelectedText, insertText} from "../../taskpane";
import {useAssistantService} from "../../../utils/services/http.service";

const useStyles = makeStyles({
    page: {
        display: "flex",
        flexDirection: "column",
        alignItems: "stretch",
        width: "100%",
        maxWidth: "100%",
        minWidth: 0,
        boxSizing: "border-box",
        rowGap: "12px",
    },
    button: {
        width: "100%",
        maxWidth: "100%",
        minWidth: 0,
        height: "auto",
        whiteSpace: "normal",
        justifyContent: "center",
        columnGap: "8px",
    },
    buttonLabel: {
        minWidth: 0,
        whiteSpace: "normal",
        overflowWrap: "anywhere",
    },
    full_width: {
        width: "100%",
        maxWidth: "100%",
        minWidth: 0,
    },
});

function Correcteur() {
    const styles = useStyles();
    const {chat} = useAssistantService();
    const [progress, setProgress] = useState(false);

    const [initialInputValue, setInitialInputValue] = useState("");
    const [correctedInputValue, setCorrectedInputValue] = useState("");

    const handleInitialTextChange = async (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        setInitialInputValue(event.target.value);
    };
    const handleCorrectedTextChange = async (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        setCorrectedInputValue(event.target.value);
    };

    const generateCorrection = async (text: string) => {
        setProgress(true);

        chat(`Corrige ce texte : "${text}". Donne moi uniquement le texte corrigé.`)
            .then((reponse) => {
                setProgress(false);
                setCorrectedInputValue(reponse);
            });
    };

    async function lancerCorrection(): Promise<void> {
        let text = await getSelectedText();
        setInitialInputValue(text);

        await generateCorrection(text);
    }

    async function regenererCorrection(): Promise<void> {
        await generateCorrection(initialInputValue);
    }

    function remplacerTexte(): any {
        insertText(correctedInputValue);
    }

    return (
        <div className={styles.page}>
            <Button className={styles.button} appearance="primary" onClick={lancerCorrection}>
                <PenSparkle20Regular/>
                <span className={styles.buttonLabel}>Corriger le texte séléctionné</span>
            </Button>
            <Field className={styles.full_width} label="Texte initial" size="medium">
                <Textarea className={styles.full_width} rows={8} value={initialInputValue} onChange={handleInitialTextChange}/>
            </Field>
            {progress && <Spinner size="small"/>}
            <Button className={styles.button} appearance="primary" onClick={regenererCorrection}>
                <PenSparkle20Regular/>
                <span className={styles.buttonLabel}>Régénerer la correction</span>
            </Button>
            <Field className={styles.full_width} label="Texte corrigé" size="medium">
                <Textarea className={styles.full_width} rows={8} value={correctedInputValue} onChange={handleCorrectedTextChange}/>
            </Field>
            <Button className={styles.button} appearance="primary" onClick={remplacerTexte}>
                <CalligraphyPenCheckmark20Regular/>
                <span className={styles.buttonLabel}>Insérer le texte corrigé</span>
            </Button>
        </div>
    );
}

export default Correcteur;
